









































































































































import {Component, Provide, Vue, Watch} from 'vue-property-decorator';
import {Action, State} from 'vuex-class';
import axios from 'axios';
import {baseUrlAPI} from '@/globals';
import ErrorNotifier from '@/domain/util/notifications/ErrorNotifier';
import SuccessNotifier from '@/domain/util/notifications/SuccessNotifier';
import HomeFooter from '@/components/common/home/HomeFooter.vue';
import Router from '@/router';

@Component({components: {HomeFooter}})
export default class Registration extends Vue {

    @Provide()
    public date = new Date();

    @Provide()
    public isLoad = false;

    @Provide()
    public autoRedirectSeconds = -1;

    @Provide()
    public user = {
        contractor: '',
        inn: '',
        firstname: '',
        lastname: '',
        middlename: '',
        post: '',
        phone: '',
        email: '',
        confirmed_politics: true,
        confirmed_personal_data: false,
    };

    @Provide() public fields: any;

    public isDisabled() {
        return !Object.keys(this.fields).every((key) => this.fields[key].valid);
    }

    public async registration() {
        this.isLoad = true;
        try {
            const result = await axios.post(`${baseUrlAPI}register`, this.user);
            if (result.status === 200) {
                SuccessNotifier.notify('Запрос отправлен', 'Запрос на регистрацию нового пользователя отправлен Администратору. Результат Вы получите на указанный Email');
                this.autoRedirectSeconds = 10;
                setTimeout(this.tick, 1000);
            } else {
                ErrorNotifier.notify();
            }

        } catch {
            ErrorNotifier.notify();
        }
        this.isLoad = false;
    }

    public tick() {
        if (this.autoRedirectSeconds === 1) {
            Router.push({name: 'home'});
            return;
        }
        this.autoRedirectSeconds--;
        setTimeout(this.tick, 1000);
    }

}
